import { render, staticRenderFns } from "./Loykathong.vue?vue&type=template&id=040ba616&scoped=true&"
import script from "./Loykathong.vue?vue&type=script&lang=js&"
export * from "./Loykathong.vue?vue&type=script&lang=js&"
import style0 from "./Loykathong.vue?vue&type=style&index=0&id=040ba616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ba616",
  null
  
)

export default component.exports